import React from "react";

export const touch = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="grain_24px">
        <path
          d="M18.2642 12.94L15.0242 11.32C16.3142 10.32 17.1442 8.76 17.1442 7C17.1442 3.97 14.6742 1.5 11.6442 1.5C8.61422 1.5 6.14422 3.97 6.14422 7C6.14422 9.13 7.36422 10.98 9.14422 11.89V15.15L7.30422 14.76L7.20422 14.74C7.10422 14.72 7.00422 14.71 6.88422 14.71C6.35422 14.71 5.85422 14.92 5.47422 15.3L4.07422 16.72L9.16422 21.81C9.59422 22.25 10.1942 22.5 10.8142 22.5H17.1142C18.0942 22.5 18.9242 21.8 19.0842 20.83L19.8842 16.12C20.1042 14.82 19.4542 13.54 18.2642 12.94ZM17.9142 15.79L17.1142 20.5H10.8142C10.7242 20.5 10.6442 20.46 10.5742 20.4L6.89422 16.72L11.1442 17.61V7C11.1442 6.72 11.3642 6.5 11.6442 6.5C11.9242 6.5 12.1442 6.72 12.1442 7V13H13.9042L17.3642 14.73C17.7642 14.93 17.9842 15.36 17.9142 15.79ZM11.6442 3.5C9.71422 3.5 8.14422 5.07 8.14422 7C8.14422 7.95 8.52422 8.81 9.14422 9.44V7C9.14422 5.62 10.2642 4.5 11.6442 4.5C13.0242 4.5 14.1442 5.62 14.1442 7V9.44C14.7642 8.81 15.1442 7.95 15.1442 7C15.1442 5.07 13.5742 3.5 11.6442 3.5Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};
